import { render, staticRenderFns } from "./update-form.vue?vue&type=template&id=70ce9f18&scoped=true&"
import script from "./update-form.vue?vue&type=script&lang=js&"
export * from "./update-form.vue?vue&type=script&lang=js&"
import style0 from "./update-form.vue?vue&type=style&index=0&id=70ce9f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce9f18",
  null
  
)

export default component.exports